// extracted by mini-css-extract-plugin
module.exports = {"technologies__table":"technologies-table_technologies__table__3UfPg","technologies__table_active":"technologies-table_technologies__table_active__hmAFO"};